<template>
	<tr :id="'product-' + data.shopping_cart_code">
		<td class="ww-image">
			<NuxtLink :to="data.item.url_without_domain">
				<BaseUiImage loading="lazy" :data="data.item?.image_thumbs?.['width65-height95']" default="/images/no-image-65.jpg" :alt="data.item.title" />
			</NuxtLink>
		</td>
		<td class="ww-cnt">
			<div class="ww-title">
				<NuxtLink :to="data.item.url_without_domain">{{ data.item.title }}</NuxtLink>
			</div>
			<div class="ww-code"><BaseCmsLabel code="code" />: {{ data.item.code }}</div>
		
			<div class="ww-price">
				<!-- <div v-if="data.total_basic > data.total" class="ww-old-price product_total_basic"><BaseUtilsFormatCurrency :price="data.total_basic" /></div> -->
				<div :class="['product_total', (data.total_basic > data.total ? 'ww-discount-price' : 'ww-current-price')]"><BaseUtilsFormatCurrency :price="data.total" /></div>
				<span class="ww-product-qty product_qty" v-if="data.quantity > 1">
					{{ data.quantity }} x <BaseUtilsFormatCurrency :price="data.unit_price" />
				</span>
				<div class="ww-extra-lowest-price" v-if="data.extra_price_lowest && data.discount_percentage > 0 && data.extra_price_lowest > 0">
					<BaseCmsLabel code="extra_price_lowest" tag="span" />: <strong><BaseUtilsFormatCurrency :price="data.extra_price_lowest" /></strong>
				</div>
			</div>
		</td>
	</tr>
</template>

<script setup>
	const props = defineProps(['data', 'mode']);
</script>

<style lang="less" scoped>
	.ww-image{height: 100px; width: 100px; vertical-align: middle !important; padding-right: 15px !important;
		:deep(img){display: block; width: auto; height: auto; max-height: 100%; max-width: 95%;}
		a{display: block;width: 100px; height: 100px; display: flex; align-items: center; justify-content: center;}
	}
	.ww-cnt{width: 100%; position: relative; padding-top: 6px !important; padding-right: 170px !important}
	.ww-title{
		font-size: 16px; line-height: 1.2; padding-bottom: 3px; max-width: 245px; font-weight: 300;
		a{color: var(--textColor); text-decoration: none;}
	}
	.ww-code{color: rgba(43,44,55,0.5); font-size: 12px; line-height: 16px;}
	.ww-price{font-size: 18px; line-height: 24px; position: absolute; top: 7px; right: 0; font-weight: normal; text-align: right; max-width: 170px;}
	.ww-old-price,.ww-product-qty{display: block; text-decoration: line-through; font-size: 12px; line-height: 15px; font-weight: normal; padding-bottom: 1px;}
	.ww-discount-price{display: block; padding-bottom: 1px; font-weight: bold;}
	.ww-extra-lowest-price{font-size: 12px; line-height: 16px; color: #98989F; display: block; padding-top: 4px;}
	.ww-product-qty{text-decoration: none; color: var(--textColor);}
</style>
